import React, { Component } from "react";
import PropTypes from "prop-types";
import Svg from "react-svg-inline";
import getOr from "lodash/fp/getOr";

import styles from "./index.module.css";
import logoAtomico from "./logoAtomico.svg";
import ChapterAnimation from "../ChapterAnimation";
import PrimaryButton from "../PrimaryButton";
/**
 * Provides a simple wrapper around components, laying them out in the style
 * of an overview page.
 */
class OverviewLayout extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // push section details into state so we can use them in the nav
    this.props.setNavSection(false, this.props.overview.props.title);
  }

  render() {
    const { overview, previews } = this.props;
    const nextPath = getOr(null, "props.nextPath", overview);
    return (
      <div className={styles.root}>
        <ChapterAnimation />
        <div className={styles.overview}>
          <section className={styles.section}>
            <div className={styles.sectionInner}>
              <header className={styles.header}>
                <h1 className={styles.headerItem}>
                  <a
                    href="http://atomico.com"
                    className={styles.logoLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Svg
                      className={styles.atomicoLogoImage}
                      svg={logoAtomico}
                      alt="Atomico logo"
                    />
                  </a>
                </h1>
                <h2 className={styles.headerItem}>
                  The State of European Tech 2017
                </h2>
              </header>
              {overview}
              {nextPath && (
                <div className={styles.nextLargeBp}>
                  <PrimaryButton to={nextPath} type="link">
                    Next Chapter
                  </PrimaryButton>
                </div>
              )}
            </div>
          </section>
        </div>
        <div className={styles.previews}>{previews}</div>
        {nextPath && (
          <div className={styles.nextSmallBp}>
            {" "}
            <PrimaryButton to={nextPath} type="link">
              Next Chapter
            </PrimaryButton>
          </div>
        )}
      </div>
    );
  }
}

OverviewLayout.propTypes = {
  overview: PropTypes.element,
  previews: PropTypes.element,
  setNavSection: PropTypes.func
};
export default OverviewLayout;



// WEBPACK FOOTER //
// ./src/components/OverviewLayout/index.js